<div class="modal-header" id="material-order-fedex-location-title">
    <h3 class="modal-title" [translate]="'MATERIAL_ORDER_FEDEX_MODAL_TITLE'"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    @if (fedexLocationForm) {
        <form [formGroup]="fedexLocationForm">
            <fieldset formArrayName="formChildren">
                <!-- Address top section -->
                <div class="row mb-2 align-items-end">
                    <div class="gap-xl-2 gap-lg-1 row col-xl-11 col-12 pe-0">
                        <div class="col-lg-3 col-md-4 col-12">
                            <label
                                for="street"
                                class="col-form-label"
                                [translate]="'MATERIAL_ORDER_FEDEX_STREET_LABEL'"
                            ></label>
                            <pace-core-text-input
                                id="street"
                                [(model)]="model.street"
                                [parentForm]="formChildren"
                            ></pace-core-text-input>
                        </div>
                        <div class="col-lg-2 col-md-4 col-12">
                            <label
                                for="city"
                                class="col-form-label"
                                [translate]="'MATERIAL_ORDER_FEDEX_CITY_LABEL'"
                            ></label>
                            <pace-core-text-input
                                id="city"
                                [(model)]="model.city"
                                [parentForm]="formChildren"
                            ></pace-core-text-input>
                        </div>
                        <div class="col-lg-2 col-md-4 col-12">
                            <label
                                for="zip"
                                class="col-form-label"
                                [translate]="'MATERIAL_ORDER_FEDEX_ZIP_LABEL'"
                            ></label>
                            <pace-core-text-input
                                id="zip"
                                [(model)]="model.zipCode"
                                [parentForm]="formChildren"
                            ></pace-core-text-input>
                        </div>
                        @if (model.statesOfUSA) {
                            <div class="col-lg-2 col-md-6 col-12">
                                <label
                                    for="state"
                                    class="col-form-label"
                                    [translate]="'MATERIAL_ORDER_FEDEX_STATE_LABEL'"
                                ></label>
                                <pace-core-dropdown
                                    id="state"
                                    [(model)]="model.statesOfUSA"
                                    [parentForm]="formChildren"
                                ></pace-core-dropdown>
                            </div>
                        }
                        <div class="col-lg-2 col-6">
                            <label
                                for="country"
                                class="col-form-label d-flex"
                                [translate]="'MATERIAL_ORDER_FEDEX_COUNTRY_LABEL'"
                            ></label>
                            <pace-core-dropdown [(model)]="model.country"></pace-core-dropdown>
                        </div>
                    </div>
                    <div class="col-xl-1 d-flex justify-content-xl-start justify-content-end mt-xl-0 mt-3 pe-4">
                        @if ({ online: (isOnline$ | async) }; as status) {
                            <button
                                type="button"
                                class="btn"
                                [ngClass]="status.online ? 'btn-primary' : 'btn-danger'"
                                [disabled]="fedexLocationForm.invalid || !status.online || isLoadingFedex"
                                (click)="getFedexLocations()"
                            >
                                @if (!status.online) {
                                    <fa-icon [icon]="faBan" size="lg" class="icon-offline"></fa-icon>
                                } @else {
                                    <span [translate]="'MATERIAL_ORDER_FEDEX_SEARCH_BTN_LABEL'"></span>
                                }
                            </button>
                        }
                    </div>
                </div>
            </fieldset>
        </form>
    }
    <hr class="separator mb-4" />
    <!-- Fedex locations table and filter section -->
    <div class="row">
        <div class="row pb-2 pe-0">
            <div class="col-lg-8 col-10">
                <pace-core-text-input
                    [(model)]="filterCriteriaModel"
                    (keyup)="onFilterCriteriaChange($event)"
                ></pace-core-text-input>
            </div>
            <button
                type="button"
                class="btn btn-primary col-lg-1 col-2"
                (click)="clearFilter()"
                [translate]="'MATERIAL_ORDER_FEDEX_CLEAR_BTN_LABEL'"
            ></button>
        </div>
        <div class="table-header fw-bold py-2">
            <div class="row align-items-center">
                <div class="col-xl-11 col-12 d-flex">
                    <div class="col-1 d-block d-xl-none"></div>
                    <div class="col-xl-2 col-4">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_LOCATION_NAME_LABEL'"></span>
                    </div>
                    <div class="col-1 d-none d-xl-block">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_CITY_LABEL'"></span>
                    </div>
                    <div class="col-xl-1 col-3">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_STREET_LABEL'"></span>
                    </div>
                    <div class="col-1">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_DISTANCE_LABEL'"></span>
                    </div>
                    <div class="col-1 d-none d-xl-block">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_MONDAY_LABEL'"></span>
                    </div>
                    <div class="col-1 d-none d-xl-block">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_TUESDAY_LABEL'"></span>
                    </div>
                    <div class="col-1 d-none d-xl-block">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_WEDNESDAY_LABEL'"></span>
                    </div>
                    <div class="col-1 d-none d-xl-block">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_THURSDAY_LABEL'"></span>
                    </div>
                    <div class="col-1 d-none d-xl-block">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_FRIDAY_LABEL'"></span>
                    </div>
                    <div class="col-1 d-none d-xl-block">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_SATURDAY_LABEL'"></span>
                    </div>
                    <div class="col-1 d-none d-xl-block">
                        <span [translate]="'MATERIAL_ORDER_FEDEX_SUNDAY_LABEL'"></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- Desktop -->
        @for (fedexLocation of fedexLocations$ | async; track fedexLocation) {
            <div class="table-row d-none d-xl-block">
                <div class="row align-items-center py-1">
                    <div class="col-11 d-flex">
                        <div class="col-2">
                            <span>{{ fedexLocation.Address.Description }}</span>
                        </div>
                        <div class="col-1">
                            <span>{{ fedexLocation.Address.City }}</span>
                        </div>
                        <div class="col-1">
                            <span>{{ fedexLocation.Address.Street }}</span>
                        </div>
                        <div class="col-1">
                            <span>{{ fedexLocation.Distance | roundMiles }}</span>
                        </div>
                        @for (entry of getWeeklySchedule(fedexLocation) | keyvalue: compareKeys; track entry.key) {
                            @if (entry.value?.Begin && entry.value?.End) {
                                <div class="col-1">{{ entry.value.Begin }} - {{ entry.value.End }}</div>
                            }
                        }
                    </div>
                    <div class="col-1">
                        <button
                            type="button"
                            class="btn btn-primary"
                            (click)="selectFedexLocation(fedexLocation)"
                            [translate]="'MATERIAL_ORDER_FEDEX_SELECT_BTN_LABEL'"
                        ></button>
                    </div>
                </div>
            </div>
        }
        @if (!hasFedexError && hasLoadedFedexLocation && (fedexLocations$ | async)?.length === 0) {
            <div class="text-center" [translate]="'MATERIAL_ORDER_FEDEX_EMPTY_SEARCH_RESULTS_LABEL'"></div>
        }
        @if (isLoadingFedex) {
            <div class="my-2">
                <progressbar [value]="100" type="default">Searching FedEx locations... </progressbar>
            </div>
        }
        <!-- Mobile screen -->
        @for (fedexLocation of fedexLocations$ | async; track fedexLocation) {
            <div class="table-row d-xl-none d-block">
                <pace-material-fedex-locations-expandable
                    [fedexLocation]="fedexLocation"
                    (selectFedexLocationEvent)="selectFedexLocation(fedexLocation)"
                >
                </pace-material-fedex-locations-expandable>
            </div>
        }
    </div>
</div>
